import type { IRhizomPageProps } from "@/types/RhizomPageProps/RhizomPageProps";
import { usePage } from "@inertiajs/vue3";
import { computed } from "vue";
import { create } from "@/composables/useNotifications";
import { useTranslations } from "@/composables/useTranslations";

export default () => {
    const { t } = useTranslations();
    const inertiaProps = usePage<IRhizomPageProps>();

    const teamRoleKey = computed(
        () => inertiaProps.props?.team_role?.key ?? null,
    );

    const canManipulateDomains = computed(() => {
        return teamRoleKey.value === "owner" || teamRoleKey.value === "admin";
    });

    const domainManipulationDisabledMessage = computed(() => {
        return canManipulateDomains.value
            ? ""
            : t("vue.domain_management_role_required");
    });

    const notifyDomainManipulationDenied = () => {
        if (canManipulateDomains.value) {
            return;
        }

        create({
            title: t("vue.domain_management_role_required"),
            type: "info",
        });
    };

    const ensureCanManipulateDomains = (): boolean => {
        if (canManipulateDomains.value) {
            return true;
        }

        notifyDomainManipulationDenied();

        return false;
    };

    return {
        canManipulateDomains,
        domainManipulationDisabledMessage,
        notifyDomainManipulationDenied,
        ensureCanManipulateDomains,
    };
};
